/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
"use client"

import React from "react"
import { useFormContext } from "react-hook-form"

import type { TextareaProps } from "./textarea"
import { get } from "../../../helpers"
import { Textarea } from "./textarea"

type FormTextareaProps = TextareaProps

export const FormTextarea = React.memo(
	({ name, ...props }: FormTextareaProps) => {
		const {
			formState: { errors },
			register,
		} = useFormContext()
		const error = get(errors, name)
		return (
			<Textarea
				{...props}
				errorMessage={error ? String(error.message) : undefined}
				{...register(name, {
					onChange: (event) => {
						if (props.onChange) {
							props.onChange(event)
						}
					},
					onBlur: (event) => {
						if (props.onBlur) {
							props.onBlur(event)
						}
					},
				})}
			/>
		)
	},
)
